module.exports = __webpack_public_path__ + "static/img/main.a41f29a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/home/main.jpg
// module id = eOQW
// module chunks = 1